import useRequest from 'src/hook/useRequest'
import { ProductsEndpoints } from 'src/services/products/constants'
import { getMyProductsProgress } from 'src/services/products'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { UseMyProductsProgressProps } from './useMyProductsProgress.types'

const useMyProductsProgress = ({ enabled, ucode }: UseMyProductsProgressProps) => {
  const response = useRequest(
    ProductsEndpoints.getMyProductsProgress(ucode),
    () => getMyProductsProgress(ucode),
    {
      enabled,
      ...DEFAULT_CACHE_CONFIG
    }
  )

  return {
    ...response,
    isLoading: enabled ? response.isLoading : false
  }
}

export default useMyProductsProgress
